<div class="single-banner text-center mt-4 mb-4">
	<div class="container-fluid container-mobile">
		<div class="row">
			<div class="col-12">
				<swiper-container #swiper class="pb-5" init="false">
					@for (banner of homeData?.newBanners; track trackByFn(i); let i = $index) {
						<swiper-slide>
							<div class="banner-home" [routerLink]="[banner.urlRedirect]" routerLinkActive="router-link-active">
								@if (!isMobile) {
									<div class="first-banner">
										<img class="img-fluid h-100" fetchpriority="high" [alt]="banner.desktopPrimary?.alt" [src]="banner.desktopPrimary?.src" [loading]="i == 0 ? 'eager' : 'lazy'" />
									</div>
									<div class="second-banner">
										<div>
											<img class="img-fluid h-100" fetchpriority="high" [alt]="banner.desktopSecondary?.alt" [src]="banner.desktopSecondary?.src" [loading]="i == 0 ? 'eager' : 'lazy'" />
										</div>
										<div>
											<img class="img-fluid h-100" fetchpriority="high" [alt]="banner.desktopTertiary?.alt" [src]="banner.desktopTertiary?.src" [loading]="i == 0 ? 'eager' : 'lazy'" />
										</div>
									</div>
									<div class="text-banner">
										<section class="d-flex w-100 justify-content-center">
											@if (banner.textBanner?.smallTitle && i == 0) {
												<h1 class="mb-1" [innerHtml]="banner.textBanner?.smallTitle"></h1>
											}
											@if (banner.textBanner?.smallTitle && i != 0) {
												<h2 class="mb-1" [innerHtml]="banner.textBanner?.smallTitle"></h2>
											}
											@if (banner.textBanner?.bigTitle) {
												<p class="mb-2" [innerHtml]="banner.textBanner?.bigTitle"></p>
											}
											@if (banner.textBanner?.description) {
												<span class="mb-3" [innerHtml]="banner.textBanner?.description"></span>
											}
											@if (banner.textBanner?.price) {
												<span [innerHtml]="banner.textBanner?.priceDescription"></span>
												<div class="price">{{ banner.textBanner?.price | removeDecimalsCurrency }}</div>
												<span class="price-subtitle" [innerHtml]="banner.textBanner?.priceSubtitle"></span>
											}
											<a [routerLink]="[banner.urlRedirect]" class="btn btn-primary mt-3">
												{{ banner.textBanner?.buttonLabel }}
											</a>
										</section>
									</div>
								} @else {
									<div class="first-banner h-auto pe-2">
										<div class="h-75 w-100 d-flex pb-2">
											<img class="img-fluid h-100 w-100 mobile-image-one" [alt]="banner.mobilePrimary?.alt" [src]="banner.mobilePrimary?.src" [loading]="i == 0 ? 'eager' : 'lazy'" fetchpriority="high" />
										</div>
										<div class="h-25 w-100 d-flex">
											<img class="img-fluid h-100 w-100 mobile-image-two" [alt]="banner.mobileSecondary?.alt" [src]="banner.mobileSecondary?.src" [loading]="i == 0 ? 'eager' : 'lazy'" fetchpriority="high" />
										</div>
									</div>
									<div class="text-banner h-auto">
										<section>
											<div>
												@if (banner.textBanner?.smallTitle && i == 0) {
													<h1 class="mb-1" [innerHtml]="banner.textBanner?.smallTitle"></h1>
												}
												@if (banner.textBanner?.smallTitle && i != 0) {
													<h2 class="mb-1" [innerHtml]="banner.textBanner?.smallTitle"></h2>
												}
												@if (banner.textBanner?.bigTitle) {
													<p class="mb-3" [innerHtml]="banner.textBanner?.bigTitle"></p>
												}
											</div>
											@if (banner.textBanner?.description) {
												<span class="mb-3" [innerHtml]="banner.textBanner?.description"></span>
											}
											@if (banner.textBanner?.price) {
												<div>
													<span [innerHtml]="banner.textBanner?.priceDescription"></span>
													<div class="price">{{ banner.textBanner?.price | removeDecimalsCurrency }}</div>
													<span class="price-subtitle" [innerHtml]="banner.textBanner?.priceSubtitle"></span>
												</div>
											}
											<a [routerLink]="[banner.urlRedirect]" class="btn btn-primary mobile mt-3">
												{{ banner.textBanner?.buttonLabel }}
											</a>
										</section>
									</div>
								}
								@if (isLoadingContent) {
									<div class="swiper-lazy-preloader"></div>
								}
							</div>
						</swiper-slide>
					}
				</swiper-container>
			</div>
		</div>
	</div>
</div>

<div class="why-sign">
	<div class="container-fluid why-sign-height">
		<div class="row">
			<div class="col-12">
				<h2 class="block-title">
					<span>{{ homeData?.whySignItems?.smallTitle }}</span>
					{{ homeData?.whySignItems?.bigTitle }}
				</h2>
			</div>
		</div>
		<div class="row why-item-container">
			@for (item of homeData?.whySignItems?.items; track item) {
				<div class="col-12 why-item-content">
					<div class="why-item">
						<div class="title">
							<img [src]="item?.icon" width="48" height="48" alt="" loading="lazy" />
							{{ item?.title }}
						</div>
						<div class="text">
							{{ item?.text }}
						</div>
					</div>
				</div>
			}
		</div>
	</div>
</div>

<div class="cars" #carsArea>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<h2 class="block-title">
					<span>{{ homeData?.featuredCars?.smallTitle }}</span>
					{{ homeData?.featuredCars?.bigTitle }}
				</h2>
			</div>
		</div>
		<div class="row">
			@for (car of homeData?.featuredCars?.cars; track car; let i = $index) {
				<div [ngClass]="i == 0 || i == 2 ? 'd-block d-md-flex justify-content-end col-md-5 offset-md-1' : 'col-md-5'" class="">
					<div class="car-card">
						<div class="image">
							<img width="300" height="200" [src]="returnImage(car?.acf?.imagem!)" [alt]="car?.acf?.marca + ' ' + car?.post_title" loading="lazy" />
						</div>
						<div class="content">
							<div class="car">
								<h3 class="brand">
									{{ car?.acf?.marca }}
								</h3>
								<h3 class="model">
									{{ getName(car?.post_title || '', 'model') }}
								</h3>
								<h3 class="type">
									{{ getName(car?.post_title || '', 'version') }}
								</h3>
							</div>
							<div class="rent">
								<div class="price">
									<div class="label">
										{{ textHome.tuitionTo }}
										@if (isMobile) {
											<br />
										}
										{{ textHome.from }}
										@if (isMobile) {
											<strong>{{ getPrice(car?.acf?.annataid!) | removeDecimalsCurrency }}</strong>
										}
									</div>
									@if (!isMobile) {
										<div class="value">{{ getPrice(car?.acf?.annataid!) | removeDecimalsCurrency }}</div>
									}
								</div>
								<a class="cta" routerLink="/simulador/elegir-renta-de-carro">
									{{ textHome.doSimulation }}
									<img width="10" height="15" src="/assets/icons/svg/arrow-right-orange.svg" alt="Faça uma simulação" loading="lazy" />
								</a>
							</div>
						</div>
					</div>
				</div>
			}
		</div>
		<div class="row">
			<div class="col-12 d-flex justify-content-center">
				<a [routerLink]="[homeData?.featuredCars?.buttonUrl]" class="btn btn-primary">
					{{ homeData?.featuredCars?.buttonLabel }}
				</a>
			</div>
		</div>
	</div>
</div>

<div class="how-sign">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<h2 class="block-title">
					<span>{{ homeData?.howToSign?.smallTitle }}</span>
					{{ homeData?.howToSign?.bigTitle }}
				</h2>
			</div>
		</div>
		<div class="container-wraper">
			@for (item of homeData?.howToSign?.items; track item; let i = $index) {
				<div class="content-wraper" [ngClass]="i === 3 ? 'last-content-wraper' : ''">
					<div class="step text-content-container">
						<div class="step-head">
							<div class="number">
								{{ i + 1 }}
							</div>
							<div class="title" [innerHTML]="isMobile ? (item.title || '' | removeTagBr) : item.title"></div>
						</div>
						<div class="step-content text-center text-md-start d-block d-md-flex">
							<div class="description" [innerHTML]="item.text"></div>
						</div>
					</div>
					@if (i !== 3) {
						<div class="arrow-images-container">
							<img class="mt-4" width="40" height="28" src="/assets/icons/svg/arrow-down-big.svg" [alt]="item.text" loading="lazy" />
						</div>
					}
				</div>
			}
		</div>
	</div>
</div>

<div class="what-included">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<h2 class="block-title">
					<span>{{ homeData?.includedOnSign?.smallTitle }}</span>
					{{ homeData?.includedOnSign?.bigTitle }}
				</h2>
			</div>
		</div>
		<div class="row">
			@for (item of homeData?.includedOnSign?.items; track item; let i = $index) {
				<div class="col g-3">
					<div class="included-box">
						<div class="head">
							<img [src]="item?.icon" class="icon" width="50" height="50" alt="" loading="lazy" />
							<h3 class="title mb-0" [innerHTML]="item.title"></h3>
						</div>
						<p class="description mb-0" [innerHTML]="item.text"></p>
					</div>
				</div>
			}
		</div>
		<div class="row">
			<div class="mt-4 col-12 d-flex justify-content-center">
				<a [routerLink]="[homeData?.includedOnSign?.buttonUrl]" class="btn btn-primary">
					{{ homeData?.includedOnSign?.buttonLabel }}
				</a>
			</div>
		</div>
	</div>
</div>

<!-- UNDER CONSTRUCTION -->
<!-- <div class="d-flex justify-content-center align-center">
  <div class="construction" style="
    position: absolute;
    top: 0px;
    margin: 70px auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    width: 80%;">
      <h1 style="font-size: 36px;
    color: #333;">Página en Construcción</h1>
      <p style="font-size: 18px;
    color: #666;">Estamos trabajando para brindar una experiencia increíble pronto. ¡Vuelve pronto!</p>
</div>
</div> -->
